var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.bannerContent)?_c('b-card',{attrs:{"no-body":""}},[_c('div',{staticClass:"p-0"},[_c('img',{attrs:{"src":"/public/img/family.png","width":"100%","alt":"","srcset":""}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }